import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useFeatureFlag from 'featureFlags/useFeatureFlag';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import Select from 'components/Inputs/Select/Select';
import './LanguageSelect.scss';

const LanguageSelect = ({ id, classes }) => {
  const { i18n } = useTranslation();
  const history = useHistory();
  const { id: tourId, lang, activestop } = useParams();
  const [multiLangFlag] = useFeatureFlag({ flag: 'multi-lang' });

  const {
    publicTour: { status },
    translations: { publishedTourLanguages = [] },
  } = useSelector(state => state);

  const [options, setOptions] = useState([]);
  const [currentLang, setCurrentLang] = useState('');

  // this should not be hard coded, we should move the
  // defaultLang to the tour once we enable users to set a default in the future
  const defaultLang = 'en';

  useEffect(() => {
    const current = lang || defaultLang;
    const isAvailable = publishedTourLanguages.find(l => l.code === current);
    // todo: better account for tour preview.
    if (!isAvailable && !history.location.pathname.includes('home'))
      history.push(`/share/${tourId}/stop/${activestop}`);
    else {
      if (i18n.language !== current)
        i18n.changeLanguage(current, (err, t) => {
          if (err) return console.error('something went wrong loading', err);
        });
    }
    setCurrentLang(current);
  }, [
    lang,
    defaultLang,
    publishedTourLanguages,
    history,
    tourId,
    activestop,
    i18n,
  ]);

  useEffect(() => {
    // for accessibility requirements
    document.documentElement.lang = currentLang || defaultLang;
  }, [currentLang]);

  useEffect(() => {
    const langs = publishedTourLanguages.reduce((result, lang) => {
      result.push({ name: lang.displayNameNative, value: lang.code });
      return result;
    }, []);
    setOptions(langs);
  }, [publishedTourLanguages]);

  const handleChange = ({ target: { value } }) => {
    if (history.location.pathname.match(/home\/view/)) {
      history.push(`/${value}/home/view/${tourId}/stop/${activestop}`);
    } else {
      history.push(`/${value}/share/${tourId}/stop/${activestop}`);
    }
  };

  return options.length > 1 && multiLangFlag ? (
    <div className={`language-select-wrapper ${classes}`}>
      {status === 'loading' && (
        <div className="loading-spinner">
          <ClipLoader key="loader" color={'none'} size={9} />
        </div>
      )}
      <i className="material-icons language-icon">language</i>
      <Select
        label={'Select a Language'}
        labelClass="sr-only"
        id={`language-toggle-selection_${id}`}
        selected={currentLang}
        handleChange={handleChange}
        name="languages"
        options={options}
        className="language-select"
      />
    </div>
  ) : null;
};

export default LanguageSelect;
